import * as React from "react";
const SvgChevron = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m16.9 12-4.6 6H8.5l4.6-6-4.6-6h3.8l4.6 6Z", fill: "#A6A6A6" }));
export default SvgChevron;
